// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Handgebautes SVG-Balkendiagramm: Volumen je ISO-Woche (letzte 12 Wochen)
import type { WorkoutEntry } from "@/lib/types"
import { weeklyVolume } from "@/lib/stats"

const W = 480
const H = 160
const PAD_TOP = 8
const PAD_BOTTOM = 18

export default function VolumeChart({ entries }: { entries: WorkoutEntry[] }) {
  const buckets = weeklyVolume(entries, 12)
  const max = Math.max(...buckets.map((b) => b.volume), 1)
  const bw = W / buckets.length
  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      role="img"
      aria-label="Volumen je Woche"
      style={{ display: "block", width: "100%", height: "auto" }}
    >
      {buckets.map((b, i) => {
        const h = (b.volume / max) * (H - PAD_TOP - PAD_BOTTOM)
        return (
          <g key={i}>
            <rect
              x={i * bw + 3}
              y={H - PAD_BOTTOM - h}
              width={bw - 6}
              height={b.volume > 0 ? Math.max(h, 2) : 0}
              rx={3}
              fill="var(--tanne)"
            >
              <title>{`${b.label}: ${Math.round(b.volume).toLocaleString("de-DE")} kg`}</title>
            </rect>
            {i % 2 === 1 && (
              <text x={i * bw + bw / 2} y={H - 4} textAnchor="middle" fontSize={9} fill="var(--text-muted)">
                {b.label}
              </text>
            )}
          </g>
        )
      })}
    </svg>
  )
}
